import { IonButton, IonContent, IonText } from '@ionic/react';
import SuccessLogo from 'assets/bg/withdraw-success.svg';
import React from 'react';
import './WithdrawSuccessModal.css';

type Props = {
  amount: number;
  onDismissSuccess: () => void;
};

const WithdrawSuccessModal: React.FC<Props> = ({
  amount,
  onDismissSuccess
}) => {
  return (
    <div className={'withdraw-success-modal'}>
      <IonContent>
        <div>
          <img src={SuccessLogo} alt="withdraw_success"/>
          <IonText>
            <h1>You withdrew</h1>
            <h2>{amount} sats</h2>
          </IonText>

          <IonButton expand={'block'} onClick={() => onDismissSuccess()}>
            Done
          </IonButton>
        </div>
      </IonContent>
    </div>
  );
};

export default WithdrawSuccessModal;
